import crudApi from "@serie3/common/api/crudApi";
import PublicProfilesConfig from "../../Config/Public/Profiles/PublicProfilesConfig";

const loadPublicProfileDetails = async (setProfileDetails, id) => {
    const response = await crudApi.show(
        PublicProfilesConfig.Profiles.endpoints.profileDetails,
        id
      );
      if (response !== null) {
        response.hits.hits[0]
          ? setProfileDetails(response.hits.hits[0]._source)
          : console.log("no data");
      } else {
        setProfileDetails(null);
      }
}

export default loadPublicProfileDetails;